import React from 'react';
import { motion } from 'motion/react';
import { theme } from '../../theme';
import { cn } from '../../lib/utils';

export const ProgressBar: React.FC = () => {
  return (
    <div className="fixed top-0 left-0 right-0 z-[1000] h-1 bg-brand-100 overflow-hidden">
      <motion.div
        initial={{ x: '-100%' }}
        animate={{ x: '100%' }}
        transition={{
          repeat: Infinity,
          duration: 1.5,
          ease: 'linear'
        }}
        className={cn("h-full w-1/3 rounded-full shadow-lg shadow-brand-500/20", theme.colors.brandBg)}
      />
    </div>
  );
};
